export const setLangLinks = ({ koLink, enLink }: { koLink: string, enLink: string }) => {
    const language = localStorage.getItem('cobak_lang');
    const openLink = language === 'ko'
        ? koLink
        : enLink;

    window.open(openLink, '_blank')
}